import axios from "axios";

export const fetchDashboardData = async (token) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/dashboards/list`,
      {
        headers: {
          authorizationToken: token,
        },
      }
    );
    return response.data;
  } catch (error) {
    // Optionally, you can log or transform the error here
    throw error;
  }
};

export const fetchDashboardThumbnail = async (
  { site_id, site_contentUrl, workbook_id, view_id },
  token
) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/dashboards/thumbnail`,
      {
        params: { site_id, site_contentUrl, workbook_id, view_id },
        headers: {
          authorizationToken: token,
        },
      }
    );

    // The backend already returns a Base64-encoded string
    return `data:image/png;base64,${response.data}`;
  } catch (error) {
    throw error;
  }
};

export const fetchTableauVizUrl = async ({ site_contentUrl, workbook_contentUrl, view_viewUrlName }, token) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/dashboards/viz-url-with-ticket`,
      {
        params: { site_contentUrl, workbook_contentUrl, view_viewUrlName },
        headers: {
          authorizationToken: token,
        },
      }
    );
    return response.data.vizUrlWithTicket; // assuming backend returns { url: "..." }
  } catch (error) {
    throw error;
  }
};



export const fetchDashboardDocumentation = async (token) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/dashboards/documentation`,
      {
        headers: {
          authorizationToken: token,
        },
      }
    );
    // console.log("Fetched documentation:", response.data);
    return response.data; // Assuming the documentation is in the "body" field
  } catch (error) {
    console.error("Error fetching dashboard documentation:", error);
    throw error;
  }
};